module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-mazda.ea86c82a.jpg";